module.exports = __webpack_public_path__ + "static/media/pahad.d6f04e88.png";